export const arrayDiffCustomerHasResident = (list1, list2, isUnion = false, byResident = false) => {
    var result = [];

    for (var i = 0; i < list1.length; i++) {
        var item1 = list1[i];
        var found = false;

        for (var j = 0; j < list2.length && !found; j++) {
            if (byResident) {
                found = item1.customer_id === list2[j].customer_id;
            } else {
                found = item1.resident_id === list2[j].resident_id;
            }
        }

        if (found === !!isUnion) {
            result.push(item1);
        }
    }
    return result;
}

export const arrayDiffAccess = (list1, list2, isUnion = false) => {
    var result = [];

    for (var i = 0; i < list1.length; i++) {
        var item1 = list1[i];
        var found = false;

        for (var j = 0; j < list2.length && !found; j++) {
            found = item1.access_id === list2[j].access_id;
        }

        if (found === !!isUnion) {
            result.push(item1);
        }
    }
    return result;
}

export const arrayDiffMedicines = (list1, list2, isUnion = false) => {
    var result = [];

    for (var i = 0; i < list1.length; i++) {
        var item1 = list1[i];
        var found = false;

        for (var j = 0; j < list2.length && !found; j++) {
            found = item1.medicine_id === list2[j].medicine_id;
        }

        if (found === !!isUnion) {
            result.push(item1);
        }
    }
    return result;
}